/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_InboxInputs */

const en_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

const es_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeja de entrada`)
};

const fr_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte de réception`)
};

const de_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posteingang`)
};

const ja_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信トレイ`)
};

const zh_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收件箱`)
};

const ar_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صندوق الوارد`)
};

const id_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotak Masuk`)
};

const it_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi`)
};

const ru_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входящие`)
};

const pt_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixa de Entrada`)
};

const ko_seller_nav_inbox = /** @type {(inputs: Seller_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수신함`)
};

/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Seller_Nav_InboxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_inbox = /** @type {((inputs?: Seller_Nav_InboxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_InboxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_inbox(inputs)
	if (locale === "es") return es_seller_nav_inbox(inputs)
	if (locale === "fr") return fr_seller_nav_inbox(inputs)
	if (locale === "de") return de_seller_nav_inbox(inputs)
	if (locale === "ja") return ja_seller_nav_inbox(inputs)
	if (locale === "zh") return zh_seller_nav_inbox(inputs)
	if (locale === "ar") return ar_seller_nav_inbox(inputs)
	if (locale === "id") return id_seller_nav_inbox(inputs)
	if (locale === "it") return it_seller_nav_inbox(inputs)
	if (locale === "ru") return ru_seller_nav_inbox(inputs)
	if (locale === "pt") return pt_seller_nav_inbox(inputs)
	return ko_seller_nav_inbox(inputs)
});